/**
 * useClock - Wall-clock time, ticking once a second
 *
 * The panel footer carries the clock so that a screenshot of any tab is
 * timestamped. Every event, every record and every SIP timestamp is read
 * against it.
 */

import { useEffect, useState } from 'react';

export const useClock = (isActive: boolean): Date => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!isActive) {
      return;
    }

    setNow(new Date());
    const interval = setInterval(() => setNow(new Date()), 1000);

    return () => clearInterval(interval);
  }, [isActive]);

  return now;
};
